import { useState } from "react";
import { toast } from "sonner";
import { api, apiErr } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { APP_NAME } from "@/config";
import { Button } from "@/components/ui/button";
import { Loader2 } from "lucide-react";
import { TermsConsent } from "@/components/Legal";
import { AuthShell } from "@/pages/Login";

// An existing account meets updated terms (backend legal.terms_outdated): nothing else opens until they're accepted.
export default function TermsGate() {
  const { refresh, logout } = useAuth();
  const [agreed, setAgreed] = useState(false);
  const [saving, setSaving] = useState(false);
  const accept = async () => {
    setSaving(true);
    try {
      await api.post("/auth/accept-terms", { accept_terms: true });
      await refresh();
      toast.success("Thank you. The updated terms are accepted.");
    } catch (e) { toast.error(apiErr(e)); } finally { setSaving(false); }
  };
  return (
    <AuthShell title="Our terms have changed" subtitle={`Please read and accept them to keep using ${APP_NAME}.`}>
      <div className="space-y-4" data-testid="terms-gate">
        <TermsConsent id="gate-terms" checked={agreed} onChange={setAgreed} />
        <Button className="w-full" disabled={!agreed || saving} onClick={accept} data-testid="terms-accept">
          {saving && <Loader2 className="w-4 h-4 animate-spin" />} Accept and continue
        </Button>
        <button type="button" className="block w-full text-center text-sm text-muted-foreground hover:text-foreground" onClick={logout}>
          Sign out
        </button>
      </div>
    </AuthShell>
  );
}
